import * as i from "../../contracts";
import { emptyMarket } from "../../constants";
import { MarketTemplate } from "../../data";
import { EventCardProps } from "../../blocks/EventListPresenter/components";
import { fillEmptyMarketSelections } from "../";

export const prepareEmptyMarket = (cardProps: EventCardProps, template: MarketTemplate, index): i.Market => {
    let emptyLocalMarket = { ...emptyMarket };

    emptyLocalMarket.id = `${cardProps.event.id}-empty-${index}`;
    emptyLocalMarket.selections = fillEmptyMarketSelections(template);
    emptyLocalMarket.template = template;

    return emptyLocalMarket;
}